import { ElementType, PlanetTypeData } from '@apeiron/planet'
import { BlankSVG, NextImage } from '@apeiron/temp'
import { styled } from '@mui/material'
import { ElementTag } from '@src/components/planet/detail/planetAboutSection/ElementTag'
import React from 'react'

const StyledElementTag = styled(ElementTag)`
  margin-bottom: 3px;
`

const TypeLabelText = styled('div')`
  color: #ffffff;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 5px;
  font-weight: 700;
`

const PlanetTypeIconImage = styled(NextImage)`
  width: 48px;
  height: 48px;
  margin-bottom: 5px;
`

const TypeContainer = styled('div')`
  display: flex;
  width: 72px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const PlanetTypeItem: React.FC<PlanetTypeItemProps> = props => {
  const { className, planetType, elements } = props

  return (
    <TypeContainer className={className}>
      <TypeLabelText>{planetType?.name}</TypeLabelText>
      <PlanetTypeIconImage src={planetType?.planetTypeIcon || BlankSVG} />
      {elements.map(element => {
        return <StyledElementTag element={element} key={element} />
      })}
    </TypeContainer>
  )
}

export type PlanetTypeItemProps = {
  className?: string
  planetType?: PlanetTypeData
  elements: ElementType[]
}
